export enum POSVendor {
  CONNECTOR = 'CONNECTOR',
  NCR = 'NCR',
  QST = 'QST',
  SICOM = 'SICOM',
  PARTNER = 'PARTNER',
  PRODUCT_NUMBER = 'PRODUCT_NUMBER',
  QDI = 'QDI',
  RPOS = 'RPOS',
}
